module.exports = __webpack_public_path__ + "static/media/project-8.ff7fa814.jpg";